import { Alert, Link } from "@mui/material";
import { useTranslation } from "react-i18next";

// Device brands that need extra setup steps, mapped to their guide
const DEVICE_BRAND_GUIDES = {
  16: "https://docs.trackpac.io/docs/device-guides/sensecap-t1000",
};

export default function DeviceGuideNotice({ deviceBrandId }) {
  const { t } = useTranslation("common");
  const guideUrl = DEVICE_BRAND_GUIDES[Number(deviceBrandId)];

  if (!guideUrl) {
    return null;
  }

  return (
    <Alert severity="info" sx={{ borderRadius: "8px" }}>
      {t("common.device_guide_notice")}{" "}
      <Link href={guideUrl} target="_blank" rel="noopener noreferrer">
        {t("common.view_device_guide")}
      </Link>
    </Alert>
  );
}
